import { Dimensions, Platform } from "react-native";
import { createPlatformStyles, theme } from "../../theme/theme";

export const { ids, styles } = createPlatformStyles({
  web: {
    bgImg: { flex: 1 },
    praxisBg: {
      backgroundImage: theme.colors.backgroundGradient,
    },
    gradientBg: {
      backgroundImage: theme.colors.backgroundGradient,
      height: "100vh",
    },
    mainContainer: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
      pointer: "none",
      padding: theme.spacing.sm,
    },
    headingText: {
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.mmd,
      },
      "@media (min-width: 700px)": {
        fontSize: theme.fontsize.xlg,
      },
      "@media (min-width: 1150px)": {
        fontSize: theme.fontsize.xlg,
      },
      "@media (min-width: 1681px)": {
        fontSize: theme.fontsize.xl,
      },
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold,
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,

      marginVertical: theme.margin.reg,
    },
    logoBlock: {
      marginBottom: theme.margin.xlg,
    },
    Logo: {
      width: 200,
      height: 100,
      display: "flex",
      resizeMode: "contain",
      "@media (min-width: 700px)": {
        width: 300,
        height: 120,
      },
    },
    loader: {
      display: "flex",
      flex: 1,
      backgroundColor: theme.colors.black + 50,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      height: "110%",
    },
    formBlock: {
      maxWidth: 600,
      paddingHorizontal: theme.spacing.md,
      width: Dimensions.get("window").width,
      "@media (min-width: 100px)": {
        maxWidth: 300,
        paddingHorizontal: theme.spacing.md,
      },
      "@media (min-width: 200px)": {
        maxWidth: 400,
        paddingHorizontal: theme.spacing.md,
      },
      "@media (min-width: 600px)": {
        maxWidth: 600,
        paddingLeft: 0,
        paddingRight: 0,
      },
    },
  },
  mobile: {
    bgImg: { flex: 1 },
    mainContainer: {
      flex: 1,
      justifyContent: "center",
      alignItems: "center",
    },
    headingText: {
      fontWeight: theme.fontweight.bold,
      fontFamily: theme.fontFamily.robotoSlabBold,

      fontSize: theme.fontsize.xl,
      fontStyle: "normal",
      letterSpacing: 0,
      textAlign: "left",
      color: theme.colors.white,

      marginBottom: theme.margin.md,
    },
    logoBlock: {
      marginBottom: theme.margin.xlg,
    },
    Logo: {
      width: 160,
      height: 50,
      "@media (min-width: 700px)": {
        width: 210,
        height: 65,
      },
    },
    loader: {
      display: "flex",
      flex: 1,
      backgroundColor: theme.colors.black + 50,
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      height: "110%",
    },
    formBlock: {
      maxWidth: 600,
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            maxWidth: "100%",
            paddingHorizontal: theme.spacing.md,
          },
          "@media (min-width: 600px)": {
            maxWidth: "80%",
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
        android: {
          "@media (min-width: 200px)": {
            maxWidth: "100%",
            paddingHorizontal: theme.spacing.reg,
          },
          "@media (min-width: 600px)": {
            maxWidth: "90%",
            paddingLeft: 0,
            paddingRight: 0,
          },
        },
      }),
    },
  },
});
